import { IMenhirFile } from '@/common/types/menhir/general';
import { IFile } from '@coverflex-tech/hypernova-utils';

export const transformFiles = (files: IMenhirFile[]): IFile[] =>
  files.map((file) => ({
    id: file.id,
    name: file.name,
    url: file.url,
    fileType: file.file_type,
    contentType: file.content_type,
  }));
